/* eslint-disable no-magic-numbers */
import { scaleToCover } from './utils/scaleTo';
import { getRel } from './utils/getRel';

export default function ContestBg(texture, width, height) {
	// create the contest background
	const container = new PIXI.Container();
	const bg = new PIXI.Sprite(texture);
	scaleToCover(bg, width, height);
	bg.anchor = new PIXI.Point(0.5, 0.5);
	// eslint-disable-next-line no-magic-numbers
	bg.position = getRel(0.5, 0.5);
	container.addChild(bg);
	container.cacheAsBitmap = true;

	return container;
}
